import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import React from "react";
import Accordion from "react-bootstrap/Accordion";
const TrendingSearchBlock = (props) => {
    const device = DeviceContext();
    return (React.createElement("div", { className: `Trending-search-block pdt-20 ${(device === null || device === void 0 ? void 0 : device.isDesktop) ? "" : "pdlr-15"}` },
        React.createElement(Accordion, { defaultActiveKey: "0", flush: true },
            React.createElement(Accordion.Item, { eventKey: "0" },
                React.createElement(Accordion.Header, null, "Trending"),
                React.createElement(Accordion.Body, null, props.content)))));
};
export default TrendingSearchBlock;
